import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export function ProtectedRoute({
  children,
  requireAdmin = false,
  requireFinanceiro = false,
  requireJuridico = false,
  requireEscala = false,
}: {
  children: React.ReactNode;
  requireAdmin?: boolean;
  // Papel financeiro (F1, 04/09): admin tambem passa. Esta trava so esconde a
  // tela; a autorizacao de verdade do dinheiro e do lado da clinica.
  requireFinanceiro?: boolean;
  // Área Jurídico (24/09): admin, financeiro e o papel 'juridico'.
  requireJuridico?: boolean;
  // Coordenação de escala (24/09): admin e o papel 'escala' — hoje só a tela
  // /admin, que para 'escala' mostra apenas tipos de turno e calendário.
  requireEscala?: boolean;
}) {
  const { user, isLoading } = useAuth();
  const { pathname } = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">Carregando...</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Usuário ainda não autorizado pelo admin → tela de espera
  if (user.role === "pendente") return <Navigate to="/aguardando" replace />;
  // Papel 'juridico' (o advogado) só enxerga a área Jurídico: qualquer outra
  // rota, inclusive /dashboard e o curinga, cai em /juridico.
  if (user.role === "juridico" && !pathname.startsWith("/juridico"))
    return <Navigate to="/juridico" replace />;
  if (
    requireJuridico &&
    user.role !== "admin" &&
    user.role !== "financeiro" &&
    user.role !== "juridico"
  )
    return <Navigate to="/dashboard" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (requireEscala && user.role !== "admin" && user.role !== "escala")
    return <Navigate to="/dashboard" replace />;
  if (requireFinanceiro && user.role !== "admin" && user.role !== "financeiro")
    return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
